












import { Vue, Component } from 'vue-property-decorator';
import Maps from '@/views/components/Maps/Maps.vue';
import {IHub} from '@/models/StoreModels';
import {namespace} from "vuex-class";

const hubsModule = namespace("hubs");
const shipmentStore = namespace("shipment");

@Component({
  name: 'SelectHub',
  components: {
    Maps,
  },
})
export default class SelectHub extends Vue {
  @shipmentStore.Action("setFromHubId")
  private setFromHubId!: (re: number) => void;

  @hubsModule.Getter("getHubList")
  private hubList!: IHub[];

  @hubsModule.Getter("existsOnlyOneHub")
  private existsOnlyOneHub!: boolean;

  private created() {
    if (this.existsOnlyOneHub) {
      this.updateSelectedHub(this.hubList[0]);
      this.goNextScreen();
    }
  }

  private updateSelectedHub(hub: IHub) {
    this.setFromHubId(hub.id);
    this.$emit('selectHub:updateSelected', hub);
  }

  private goNextScreen() {
    this.$uiBus.emit("dropup:close"); // todo: this is deprecated, clean it whenever you can
    this.$emit("selectHub:close");
  }
}
